if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.notTransactionalCountries = this.dataset.notTransactionalCountries.split(',')
        this.selectorOpen = false;
        this.mql = window.matchMedia('(min-width: 911px)');
        this.header = document.querySelector('.header-wrapper');
        this.footer = this.closest("footer");

        this.elements = {
          localeInput: this.querySelector('input[name="locale_code"]'),
          countryInput: this.querySelector('input[name="country_code"]'),
          button: this.querySelector('.js-countryListBtn'),
          panel: this.querySelector('.js-countryListDialog'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.js-countryListCloseBtn'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
          localizationPopup: this.querySelector('.js-localizationPopup'),
          closePopupButton: this.querySelector('.js-closeLocalizationPopup')
        };

        this.normalizeFooterCountryLabel();

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.elements.button?.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.panel) {
          this.elements.panel.addEventListener("click", (event) => {
            if (this.selectorOpen && event.target === this.elements.panel) {
              this.hidePanel();
            }
          });
  
          document.addEventListener('click', (event) => {
            if (this.selectorOpen && !this.elements.panel.contains(event.target) && !this.elements.button.contains(event.target)) {
              this.hidePanel();
            }
          });
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }
        if (this.footer && this.footer.contains(this.elements.localizationPopup)) {
          this.footer.parentElement.insertBefore(this.elements.localizationPopup, this.footer.nextSibling);
        }
        if (this.elements.localizationPopup) {
          this.updateLocalization();
          document.addEventListener('click', (event) => {
            if (!this.elements.localizationPopup.contains(event.target) && !this.elements.closePopupButton.contains(event.target)) {
              this.hidePopup();
            }
          });
        }
        if (this.elements.closePopupButton) {
          this.elements.closePopupButton.addEventListener('click', this.hidePopup.bind(this));
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', () => {
          publish("change-country");
          this.selectCountry(item);
        }));
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      normalizeFooterCountryLabel() {
        if (!this.footer || !this.elements.button) return;

        const countryLabel = this.elements.button.querySelector('.tw-typo-op-cta-small');
        const countryCode = this.elements.countryInput?.value?.trim().toUpperCase();

        if (!countryLabel) return;

        if (countryCode === 'US' || countryLabel.textContent.trim() === 'United States') {
          countryLabel.textContent = 'USA';
        }
      }

      selectCountry(item) {
        const selected = this.querySelector("#current-selected");
        if(selected) {
          selected.querySelector(".radio-checked")?.classList.add("tw-hidden");
          selected.querySelector(".radio-unchecked")?.classList.remove("tw-hidden");
        }
        item.querySelector(".radio-checked")?.classList.remove("tw-hidden");
        item.querySelector(".radio-unchecked")?.classList.add("tw-hidden");
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        
        if (this.elements.panel.close) {
          this.elements.panel.close();
        } else {
          this.elements.panel.setAttribute('hidden', true);
        }
        
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }

        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer')?.classList.remove('country-selector-open');
        
        if (this.header) {
          this.header.preventHide = false;
        }

        this.selectorOpen = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          this.elements.search.setAttribute('aria-activedescendant', focusedItemIndex > -1 ? focusableItems[focusedItemIndex].id : "");
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.selectorOpen) {
              this.hidePanel();
              event.stopPropagation();
              this.elements.button.focus();
            }
            break;
          case 'SPACE':
            if (!this.selectorOpen) {
              this.openSelector();
            }
            break;
        }
      }

      onItemClick(event) {
        const form = this.querySelector('form');
        event.preventDefault();
        const input = event.currentTarget.querySelector("input")
        if (input){
          input.checked = true
        }
        if (this.elements.countryInput && this.elements.localeInput && form) {
          this.elements.countryInput.value = event.currentTarget.dataset.country;
          this.elements.localeInput.value = event.currentTarget.dataset.locale;
  
          form.submit();
        }
      }

      openSelector() {
        this.elements.button.focus();

        if (this.elements.panel.showModal) {
          this.elements.panel.showModal();
        } else {
          this.elements.panel.removeAttribute("hidden");
        }

        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        // if (!document.body.classList.contains('overflow-hidden-tablet')) {
        //   document.body.classList.add('overflow-hidden-mobile');
        // }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.header && this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer')?.classList.add('country-selector-open');

        this.selectorOpen = true;
      }

      normalizeString(str = "") {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search?.value || "");
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton?.classList.toggle('hidden', !searchValue);
        popularCountries?.classList.toggle('hidden', searchValue);

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country')?.textContent || "");
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace('[count]', visibleCountries);
        }
      }

      resetFilter(event) {
        event.stopPropagation();

        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.focus();
        }
      }

      onSearchFocus() {
        this.elements.searchIcon?.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }

      hidePopup() {
        this.elements.localizationPopup?.setAttribute('hidden', true);
      }

      showPopup() {
        this.elements.localizationPopup?.removeAttribute('hidden');
      }

      updateLocalization() {
        if (sessionStorage.getItem('localizationUpdated') || !this.elements.localizationPopup) return;

        fetch(
          window.Shopify.routes.root
          + 'browsing_context_suggestions.json'
          + '?country[enabled]=true'
          + '&language[enabled]=true'
        )
          .then(response => response.json())
          .then(data => {
            const detectedCountry = data.detected_values.country.name;
            const countryIsoCode = data.detected_values.country.handle.toLowerCase();
            const detectedLocale = data.suggestions[0].parts.language.handle;
            const userLocation = this.elements.localizationPopup.querySelector('.js-userLocation');
            const selectedLocation = this.elements.localizationPopup.querySelector('.js-selectedLocation');

            const popupLink = userLocation?.querySelector('a');
            popupLink?.setAttribute('id', countryIsoCode);

            if (popupLink && selectedLocation?.querySelector('a').id != popupLink.id) {
              popupLink.setAttribute('data-locale', detectedLocale);
              popupLink.setAttribute('data-country', countryIsoCode);

              // popupLink.setAttribute('data-value', countryIsoCode);
              // popupLink.setAttribute('href', `/${countryIsoCode}-${countryIsoCode}`);
              const detectedCountryFlag = userLocation.querySelector('img');
              if(!this.notTransactionalCountries.includes(countryIsoCode)){
                detectedCountryFlag.src = detectedCountryFlag.src.replace(/op-flag-\w+/, `op-flag-${countryIsoCode}`);
                detectedCountryFlag.style.display = 'block'
              }else{
                this.elements.localizationPopup.querySelector('[data-not-transactional-icon]').style.display = 'block'
              }

              detectedCountryFlag.setAttribute('alt', `${detectedCountry} Flag`);
              const userCountryNames = document.querySelectorAll('.js-userCountryName');
              userCountryNames.forEach((userCountryName) => {
                userCountryName.textContent = detectedCountry;
              });
              this.showPopup();
              this.elements.localizationPopup.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
              sessionStorage.setItem('localizationUpdated', 'true');
            }
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
      }

    }
  );
}


